module.exports = __webpack_public_path__ + "static/media/MTL_SL_DS.8f70346d.png";